import React from "react";
import { func } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Row, Col, Label } from "reactstrap";
import { withError } from "../../../../components/hocs";
import { ButtonWithSpinner } from "../../../../components/common";
import FormikSwitch from "../../../../components/formik/Switch";
import "./organizationFrom.css";
import FormikInputNumberCustomArrows from "../../../../components/formik/settings/InputNumberCustomArrows";
import useRoles from "../../../../components/hooks/useRoles";
import { getRiskColor } from "../../../../utilities/riskColor";

const ErrorInput = withError(FormikInputNumberCustomArrows);

const OrganizationInfoForm = ({ handleSubmit, organizationInfo }) => {
  const { isAuditor, isMaster, isClient } = useRoles();

  const actionsDisabled = !(isAuditor || isMaster || isClient);

  return (
    <Formik
      onSubmit={handleSubmit}
      enableReinitialize
      initialValues={{
        highRiskScoreIntervalInDays:
          organizationInfo != null &&
          organizationInfo.highRiskScoreIntervalInDays != null
            ? organizationInfo.highRiskScoreIntervalInDays
            : "",
        mediumRiskScoreIntervalInDays:
          organizationInfo != null &&
          organizationInfo.mediumRiskScoreIntervalInDays != null
            ? organizationInfo.mediumRiskScoreIntervalInDays
            : "",
        normalRiskScoreIntervalInDays:
          organizationInfo != null &&
          organizationInfo.normalRiskScoreIntervalInDays != null
            ? organizationInfo.normalRiskScoreIntervalInDays
            : "",
        regularSearchingIntervalInDays:
          organizationInfo != null &&
          organizationInfo.regularSearchingIntervalInDays != null
            ? organizationInfo.regularSearchingIntervalInDays
            : "",
        negativeMediaCheckIntervalInDays:
          organizationInfo != null &&
          organizationInfo.negativeMediaCheckIntervalInDays != null
            ? organizationInfo.negativeMediaCheckIntervalInDays
            : "",
        regularSearchingNILIntervalInDays:
          organizationInfo != null &&
          organizationInfo.regularSearchingNILIntervalInDays != null
            ? organizationInfo.regularSearchingNILIntervalInDays
            : "",

        regularSearchingPEPIntervalInDays:
          organizationInfo != null &&
          organizationInfo.regularSearchingPEPIntervalInDays != null
            ? organizationInfo.regularSearchingPEPIntervalInDays
            : "",
        negativeMediaCheckingIsActive: !!(
          organizationInfo && organizationInfo.negativeMediaCheckingIsActive
        ),
        regularScoringIsActive: !!(
          organizationInfo && organizationInfo.regularScoringIsActive
        ),
        regularSearchingPEPIsActive: !!(
          organizationInfo && organizationInfo.regularSearchingPEPIsActive
        ),
        regularSearchingNILIsActive: !!(
          organizationInfo && organizationInfo.regularSearchingNILIsActive
        ),
      }}
      //key={key}
      //validationSchema={clientProfileEntriesValidationSchema}
    >
      {({ errors, values }) => (
        <Form className="settings-form-box">
          <div className="settings-form">
            <Row className="pb-4">
              <Col lg={4} className="mb-4">
                <div className="settings-card">
                  <div className="settings-card-header">
                    <Field
                      name="regularSearchingPEPIsActive"
                      component={FormikSwitch}
                      label="Watchlist Regular PEP Search"
                      disabled={actionsDisabled}
                    />
                  </div>
                  <Label>Watchlist Regular PEP Search Period (days)</Label>
                  <Field
                    type="number"
                    name="regularSearchingPEPIntervalInDays"
                    placeholder="RegularSearchingPEPIntervalInDays"
                    component={ErrorInput}
                    min={1}
                    disabled={
                      actionsDisabled || !values.regularSearchingPEPIsActive
                    }
                  />

                  <hr className="settings-card-divider" />

                  <div className="settings-card-header">
                    <Field
                      name="regularSearchingNILIsActive"
                      component={FormikSwitch}
                      label="Watchlist Regular Negative Info Search"
                      disabled={actionsDisabled}
                    />
                  </div>
                  <Label>
                    Watchlist Regular Negative Info Search Period (days)
                  </Label>
                  <Field
                    type="number"
                    name="regularSearchingNILIntervalInDays"
                    placeholder="RegularSearchingNILIntervalInDays"
                    component={ErrorInput}
                    min={1}
                    disabled={
                      actionsDisabled || !values.regularSearchingNILIsActive
                    }
                  />
                </div>
              </Col>

              <Col lg={4} className="mb-4">
                <div className="settings-card">
                  <div className="settings-card-header">
                    <Field
                      name="regularScoringIsActive"
                      component={FormikSwitch}
                      label="Regular Scoring"
                      disabled={actionsDisabled}
                    />
                  </div>

                  <Label className="pt-2 d-flex align-items-center">
                    <span
                      className="risk-dot"
                      style={{ backgroundColor: getRiskColor({ key: "high" }) }}
                    />
                    High risk clients (days)
                  </Label>
                  <Field
                    type="number"
                    name="highRiskScoreIntervalInDays"
                    placeholder="HighRiskScoreIntervalInDays"
                    component={ErrorInput}
                    min={1}
                    disabled={actionsDisabled || !values.regularScoringIsActive}
                  />

                  <Label className="pt-1 d-flex align-items-center">
                    <span
                      className="risk-dot"
                      style={{
                        backgroundColor: getRiskColor({ key: "medium" }),
                      }}
                    />
                    Medium risk clients (days)
                  </Label>
                  <Field
                    type="number"
                    name="mediumRiskScoreIntervalInDays"
                    placeholder="MediumRiskScoreIntervalInDays"
                    component={ErrorInput}
                    min={1}
                    disabled={actionsDisabled || !values.regularScoringIsActive}
                  />

                  <Label className="pt-1 d-flex align-items-center">
                    <span
                      className="risk-dot"
                      style={{
                        backgroundColor: getRiskColor({ key: "normal" }),
                      }}
                    />
                    Normal risk clients (days)
                  </Label>
                  <Field
                    type="number"
                    name="normalRiskScoreIntervalInDays"
                    placeholder="NormalRiskScoreIntervalInDays"
                    component={ErrorInput}
                    min={1}
                    disabled={actionsDisabled || !values.regularScoringIsActive}
                  />
                </div>
              </Col>

              <Col lg={4} className="mb-4">
                <div className="settings-card">
                  <div className="settings-card-header">
                    <Field
                      name="negativeMediaCheckingIsActive"
                      component={FormikSwitch}
                      label="Negative Media Check"
                      disabled={actionsDisabled}
                    />
                  </div>
                  <Label>Negative Media Check Period (days)</Label>
                  <Field
                    type="number"
                    name="negativeMediaCheckIntervalInDays"
                    placeholder="NegativeMediaCheckIntervalInDays"
                    component={ErrorInput}
                    min={1}
                    disabled={
                      actionsDisabled || !values.negativeMediaCheckingIsActive
                    }
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={8}>
                {errors.atLeastOneOf && (
                  <React.Fragment>
                    <div className="form-error-message">
                      {errors.atLeastOneOf}
                    </div>
                  </React.Fragment>
                )}
              </Col>
              <Col lg={12} className="d-flex justify-content-center pb-5 pt-5">
                <ButtonWithSpinner
                  id="searchClientProfileEntriesSubmitButton"
                  text="Save"
                  outline
                  type="submit"
                  disabled={actionsDisabled}
                  className="save-button-settings "
                  loading={false}
                />
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </Formik>
  );
};

OrganizationInfoForm.propTypes = {
  handleSubmit: func.isRequired,
};

export default OrganizationInfoForm;



// WEBPACK FOOTER //
// ./src/features/organization/components/organization-info/OrganizationInfoForm.jsx